import { render, staticRenderFns } from "./DeletePayment.vue?vue&type=template&id=3278b79a"
import script from "./DeletePayment.vue?vue&type=script&lang=js"
export * from "./DeletePayment.vue?vue&type=script&lang=js"
import style0 from "./DeletePayment.vue?vue&type=style&index=0&id=3278b79a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports